// extracted by mini-css-extract-plugin
export default {"title":"BLcUm4","icon":"pEKtqv mz-interactive-info-block__icon"};